import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Form,
  FormControl,
  FormGroup
} from 'react-bootstrap';

import request from '../../utils/Request';
import Auth from '../../utils/Auth';
import ErrorAlert from '../utils/ErrorAlert';

class ResidentialLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      error: false,
      errorMessage: ''
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.login = this.login.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox'
      ? target.checked
      : target.value;

    const { name } = target;

    this.setState({
      [name]: value
    });
  }

  componentDidMount() {
    if (Auth.isAuthenticated()) {
      switch (localStorage.getItem('role')) {
        case 'admin':
          this.props.history.push('/admin/dashboard');
          break;

        case 'owner':
          this.props.history.push('/owner/dashboard');
          break;

        case 'strataAdmin':
          this.props.history.push('/strataAdmin/dashboard');
          break;

        case 'strataUnitOwner':
          this.props.history.push('/strataUnitOwner/dashboard');
          break;

        case 'propertyAdmin':
          this.props.history.push('propertyAdmin/dashboard');
          break;

        case 'superAdmin':
          this.props.history.push('/admin/dashboard');
          break;

        default:
      }
    }
  }

  login(e) {
    e.preventDefault();

    const credentials = {
      userName: this.state.email,
      password: this.state.password,
      portal: 'residential'
    };

    request
      .login(credentials)
      .then((res) => {
        localStorage.setItem('portalOption', 'residential');

        if (
          res.user.role.indexOf('Administrator') > -1 ||
          res.user.role === 'Administrator'
        ) {
          localStorage.setItem('role', 'admin');
          this.props.history.push('/admin/dashboard');
        } else if (
          res.user.role.indexOf('Owner') > -1 ||
          res.user.role === 'Owner'
        ) {
          localStorage.setItem('role', 'owner');
          this.props.history.push('/owner/dashboard');
        } else if (
          res.user.role.indexOf('Super Administrator') > -1 ||
          res.user.role === 'Super Administrator'
        ) {
          localStorage.setItem('role', 'superAdmin');
          this.props.history.push('/admin/dashboard');
        } else {
          this.setState({
            error: true,
            errorMessage:
              'Sign in credentials not valid for residential login. Perhaps you meant to use strata login.'
          });
        }
      })
      .catch(() => {
        this.setState({
          error: true,
          errorMessage: 'Username or Password Incorrect'
        });
      });
  }

  render() {
  return (
    <div className="portal-page">

      <div className="portal-container">

        <div className="portal-card">

          <h1 className="portal-title">
            Rental Owners Portal
          </h1>

          <p className="portal-subtitle">
            Access your property documents, payments and
            communications securely.
          </p>

          <Form className="portal-form">

            <FormGroup>

              <FormControl
                name="email"
                type="text"
                placeholder="Username"
                value={this.state.email}
                onChange={this.handleInputChange}
              />

            </FormGroup>

            <FormGroup>

              <FormControl
                name="password"
                type="password"
                placeholder="Password"
                value={this.state.password}
                onChange={this.handleInputChange}
              />

            </FormGroup>

            <button
              type="submit"
              onClick={this.login}
              className="portal-button"
            >
              Sign In
            </button>

            <div className="portal-forgot">
              <Link to="/account/resetpassword">
                Forgot Password?
              </Link>
            </div>

          </Form>

          {this.state.error ? (
            <ErrorAlert errorMessage={this.state.errorMessage} />
          ) : null}

        </div>

      </div>

    </div>
  );
}
}
export default ResidentialLogin;